import { render, staticRenderFns } from "./VTokens.vue?vue&type=template&id=56c8d07e&scoped=true&"
import script from "./VTokens.vue?vue&type=script&lang=js&"
export * from "./VTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8d07e",
  null
  
)

export default component.exports